<template>
  <div />
</template>

<script>
export default {
  name: 'PagesAffiliateDashboardIndex',
  middleware({ redirect }) {
    return redirect('/');
  },
};
</script>
